import React, { useContext } from 'react'
import { Route, Switch } from 'react-router'
import AppContext from '../Store/AppContext'
import RouteSuspense from './RouteSuspense'
import { Login } from 'containers/Authentication/Login'
import { ActivatedUser } from 'containers/Authentication/ActivatedUser'
import { ForgotPassword } from 'containers/Authentication/Password/ForgotPassword'
import { PrivateRoute } from './PrivateRoute'
import { ResetPassword } from 'containers/Authentication/Password/ResetPassword'

const Routes = () => {
  const { globalState } = useContext(AppContext as any)
  return (
    <Switch>
      <Route path="/user/activate/:token">
        <ActivatedUser />
      </Route>
      <Route path="/forgot-password">
        <ForgotPassword />
      </Route>
      <Route path="/login">
        <Login />
      </Route>
      <Route path="/reset-password/:token">
        <ResetPassword />
      </Route>
      {globalState.routes.map((el, index) => {
        return (
          <PrivateRoute key={index} exact {...el.props}>
            <RouteSuspense>{el.component}</RouteSuspense>
          </PrivateRoute>
        )
      })}
    </Switch>
  )
}

export default Routes
